"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainFriction = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Kette_1 = require("./Kette");
const ArticleUtils_1 = require("../ArticleUtils");
class ChainFriction {
    static getFrictionFactor(kette, einbauart) {
        switch (einbauart) {
            case echain_shared_articles_1.Einbauart.haengend:
                return this.getFrictionFactorHanging();
            case echain_shared_articles_1.Einbauart.gleitend: {
                // .. because this is used in the kette rex filters, so we do it manually.. // we could instantiate an article here with A(kette), but we need to be blazing fast!
                const artNr = kette instanceof Kette_1.Kette ? kette.artNr : ArticleUtils_1.ArticleUtils.getQuoteArtNr(kette);
                const isRolEchain = kette instanceof Kette_1.Kette ? kette.isSerieRolEchain() : kette.KetteSerieType === echain_shared_articles_1.KetteSerieType.rolEchain;
                return this.getFrictionFactorGliding({ artNr, isRolEchain });
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(einbauart);
        }
    }
    static getFrictionFactorGliding({ artNr, isRolEchain, }) {
        // gliding friction for rol-echains EKE-10383
        if (isRolEchain) {
            // P4- or P41 ..
            if (artNr === null || artNr === void 0 ? void 0 : artNr.startsWith('P4')) {
                return this.GlidingRolEchainP4;
            }
            return this.GlidingRolEchain;
        }
        return this.GlidingStandard;
    }
    static getFrictionFactorHanging() {
        return this.HangingStandard;
    }
}
exports.ChainFriction = ChainFriction;
ChainFriction.className = 'ChainFriction';
ChainFriction.GlidingStandard = 0.3;
ChainFriction.GlidingRolEchain = 0.1;
ChainFriction.GlidingRolEchainP4 = 0.05;
ChainFriction.HangingStandard = 1;
//# sourceMappingURL=chain-friction.js.map